$('a[href="https://app.applyyourself.com/AYApplicantLogin/fl_ApplicantConnectLogin.asp?id=wbu-u"]').on('click', function(e){
	//e.preventDefault();

	ga('send', {
	  hitType: 'event',
	  eventCategory: 'Apply',
	  eventAction: 'Click',
	  eventLabel: 'Woodbury Application Undergraduate'
	});

});

$('a[href="https://app.applyyourself.com/AYApplicantLogin/fl_ApplicantConnectLogin.asp?id=woodburyg"]').on('click', function(e){
	//e.preventDefault();

	ga('send', {
	  hitType: 'event',
	  eventCategory: 'Apply',
	  eventAction: 'Click',
	  eventLabel: 'Woodbury Application Graduate'
	});

});


$('a[href="https://apply.commonapp.org/Login"]').on('click', function(e){
	//e.preventDefault();

	ga('send', {
	  hitType: 'event',
	  eventCategory: 'Apply',
	  eventAction: 'Click',
	  eventLabel: 'Common Application'
	});

});